import axios from "axios";
import Cookies from "./Cookies";

const backendUrl = process.env.REACT_APP_BACKEND ?? '';


const Axios = {
    get: (...args) => {

        if (Cookies.getSession()) {
            if(!args[1]) args[1] = {};
            if(!args[1].headers) args[1].headers = {};
            args[1].headers.session_id = Cookies.getSession();
        }

        args[0] = backendUrl + args[0];

        let query = axios.get(...args);
        query = query.then(r => {
            if (r.data.message === 'Session error') {
                Cookies.deleteSession();
                throw new Error('Session error');
            }

            if(r.headers.session_id) {
                Cookies.deleteSession();
                Cookies.setSession(r.headers.session_id);
            }

            return r.data;
        })
        return query;
    },
    post: (...args) => {

        if (Cookies.getSession()) {
            if(!args[2]) args[2] = {};
            if(!args[2].headers) args[2].headers = {};
            args[2].headers.session_id = Cookies.getSession();
        }

        args[0] = backendUrl + args[0];
        let query = axios.post(...args);

        query = query.then(r => {
            if (r.data.message === 'Session error') {
                throw new Error('Session error');
            }

            if(r.headers.session_id) {
                Cookies.setSession(r.headers.session_id);
            }

            return r.data;
        })
        return query;
    }
};

export default Axios;

